import { FormatSeriesDefaultReturn, FormatSeriesLineReturn } from "./types";

// Função auxiliar para normalizar as keys
const normalizeKeys = (keys: (string | object)[]): Record<string, string> => {
  return keys.reduce((acc: Record<string, string>, key) => {
    if (typeof key === "string") {
      acc[key] = key; // Se for string, mantém o mesmo valor
    } else if (typeof key === "object") {
      const keyName = Object.keys(key)[0];
      const keyValue = Object.values(key)[0];
      acc[keyName] = keyValue as string;
    }
    return acc;
  }, {});
};

const formatSeriesDefault = (
  data: MyDatum[],
  indexBy: string,
  keys: (string | object)[]
): FormatSeriesDefaultReturn => {
  //confere se key é um array de objetos se n±ao for retorna data e keys
  if (
    !Array.isArray(keys) ||
    keys.length === 0 ||
    (typeof keys[0] === "string" && typeof keys[0] !== "object")
  ) {
    return { formattedData: data, keyNames: keys as string[] };
  }

  const keysObj = normalizeKeys(keys);

  const formattedData = data.map((item) => {
    const newItem = { ...item };
    for (const [key, value] of Object.entries(keysObj)) {
      // Verifica se a chave é igual a indexBy
      if (key === indexBy) {
        continue; // Não altera a chave
      }
      if (key in newItem) {
        newItem[value] = newItem[key];
        delete newItem[key];
      }
    }
    return newItem;
  });

  const keyNames = Object.values(keysObj); // Extrai os nomes das keys
  return { formattedData, keyNames };
};

const formatSeriesLine = (
  data: MyDatum[],
  indexBy: string,
  keys: string[]
): FormatSeriesLineReturn => {
  const keysObj = normalizeKeys(keys);

  const formattedData = Object.entries(keysObj).map(([key, value]) => ({
    id: value, // O nome da chave será o id
    data: data.map((item) => ({
      x: item[indexBy], // O valor do eixo x (ex.: "mes")
      y: item[key], // O valor correspondente à chave (ex.: "ativos", "cancelados")
    })),
  }));

  const keyNames = Object.values(keysObj); // Extrai os nomes das keys
  return { formattedData, keyNames };
};

export { formatSeriesLine, formatSeriesDefault };
